import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const UploadPaymentProof = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedExpenses } = location.state || { selectedExpenses: [] };

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.warning("Please upload a payment screenshot");
      return;
    }

    const payload = new FormData();
    payload.append("payment_proof", file);
    payload.append("payment_status", "paid");
    payload.append("paid_by", 2); // you can dynamically set logged-in user ID
    payload.append("data", JSON.stringify(selectedExpenses));

    try {
      setLoading(true);
      const res = await axios.post("https://api.hanoch.in/expense/mark-paid/", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("✅ Payment proof uploaded successfully!");
      navigate("/ExpenseDashboard");
    } catch (err) {
      console.error("Error uploading proof:", err);
      toast.error("❌ Failed to upload payment proof");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="py-4">
      <Row className="justify-content-center">
        <Col lg="6">
          <Card className="shadow-sm border-0">
            <CardBody>
              <CardTitle tag="h5" className="text-center mb-4">
                Upload Payment Proof
              </CardTitle>
              <Form onSubmit={handleSubmit}>
                <FormGroup className="mb-3">
                  <Label>Total Selected Expenses</Label>
                  <Input
                    type="text"
                    value={selectedExpenses.length + " items"}
                    disabled
                  />
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>Upload Payment Screenshot</Label>
                  <Input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                </FormGroup>

                <div className="text-center">
                  <Button
                    color="success"
                    type="submit"
                    disabled={loading}
                    className="px-4"
                  >
                    {loading ? <Spinner size="sm" /> : "Submit Payment Proof"}
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default UploadPaymentProof;
